import { render, staticRenderFns } from "./SafetyIncidentLogDetails.vue?vue&type=template&id=84f7e97a"
import script from "./SafetyIncidentLogDetails.vue?vue&type=script&lang=js"
export * from "./SafetyIncidentLogDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports